import { objectIdSchema, paginationSchema } from './common.js';
export const auditListQuerySchema = paginationSchema.extend({
    chatId: objectIdSchema.optional(),
});
//# sourceMappingURL=audit.js.map